import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false

import ajax from "./api/ajax";
Vue.prototype.$ajax = ajax

import wx_share from "@/utils/wx_share";
Vue.prototype.wxShare = wx_share

import router from './router'
router.beforeEach((to,from,next)=>{
  const urlId = window.location.search.substring(1).split('=')[1]
  if (urlId || !to.meta.required){
    if (to.meta.title) document.title = to.meta.title
    store.commit('UNSELECTEDFOOTERNAV',to)
    next()
  }else {
    if (to.name === 'error'){
      next()
    }else {
      next('/error')
    }
  }
})


import 'amfe-flexible'
import '@/static/css/reset.css'
import store from "@/store";

import '@/utils/components'


import {Image as VanImage,Lazyload,Loading,Empty,List,DropdownMenu, DropdownItem,NavBar,Swipe, SwipeItem,ImagePreview,Popup,Field,Checkbox,Dialog,Picker,Toast,Icon,Button  } from 'vant'
Vue.use(VanImage)
Vue.use(Loading)
Vue.use(Empty)
Vue.use(List)
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(ImagePreview);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(Button);
// Vue.use(Lazyload,{loading:require('./static/images/Spinner.gif'),error:require('./static/images/broken_image.png'),lazyComponent: true})
Vue.use(Lazyload,{error:require('./static/images/broken_image.png'),lazyComponent: true})
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
